class ShoppableHeaderAddToCart extends HTMLElement {
  constructor() {
    super();
    // Set default texts for different button states
    this.addedText = "ADDED TO CART";
    this.addingText = "ADDING TO CART...";
  }

  // Lifecycle method called when the element is added to the DOM
  connectedCallback() {
    this.button = this.querySelector("#shoppable-header-add-to-cart");
    this.button.addEventListener("click", this.buttonEventHandler.bind(this));
  }

  // Lifecycle method called when the element is removed from the DOM
  disconnectedCallback() {
    this.button.removeEventListener(
      "click",
      this.buttonEventHandler.bind(this)
    );
  }

  // Event handler for the button click
  buttonEventHandler() {
    const { variantId } = this.button.dataset;
    this.addToCart(variantId);
  }

  // Method to handle adding items to the cart
  async addToCart(variantId) {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    this.button.innerHTML = this.addingText;
    this.button.disabled = true;
    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error(`ShoppableHeaderAddToCart | addToCart | ${error.message}`);
    } finally {
      this.button.innerHTML = this.addedText;
    }
  }
}
customElements.define("shoppable-header-add-to-cart", ShoppableHeaderAddToCart);
